module.exports = __webpack_public_path__ + "media/store/fonts/ft-menu-3-a251e40aa0e9a39949e884ad7f322b7e.woff";